import { createSlice } from "@reduxjs/toolkit";
import { update } from "lodash";

const Configuration = createSlice({
  name: "configuration",
  initialState: {
    current_file: "",
    pages: [],
    rooms: [],
    openings: [],
    equipments: [],
    cables: [],
    pieuvres: [],
    evitementZones: [],
    svgScale: 2,
  },
  reducers: {
    setFileConfigurationIEP: (state, action) => {
      const { current_file, pages, rooms, openings, equipments, pieuvres, cables, evitementZones, svgScale } = action.payload;

      state.current_file = current_file || "";
      state.pages = pages || [];
      state.rooms = rooms || [];
      state.openings = openings || [];
      state.equipments = equipments || [];
      state.pieuvres = pieuvres || [];
      state.cables = cables || [];
      state.evitementZones = evitementZones || [];
      state.svgScale = svgScale || 2;

    },
    updatePagesIEP: (state, action) => {
      const pages = action.payload;

      const pagesReady = state.pages.filter(x => (x.segmentation_ready === "ready")).map(x => x.page);
      const pagesFailed = state.pages.filter(x => (x.segmentation_ready === "failed")).map(x => x.page);
      const pagesOngoing = state.pages.filter(x => (x.segmentation_ready === "ongoing")).map(x => x.page);

      state.pages = pages;

      //set back segmentation_ready at a definitive state ("ready" or "failed") if it was overwritten by action.payload (set to "ongoing" or "not_started").
      for (let page of pagesReady) {
        if (state.pages[page]) {state.pages[page].segmentation_ready = "ready";}
      }
      for (let page of pagesFailed) {
        if (state.pages[page]) {state.pages[page].segmentation_ready = "failed";}
      }
      //set back segmentation_ready at "ongoing" if it was set to "not_started" by action.payload.
      for (let page of pagesOngoing) {
        if (state.pages[page]?.segmentation_ready === "not_started") {state.pages[page].segmentation_ready = "ongoing";}
      }
    },
    setCurrentFileSelectedPagesIEP: (state, action) => {
      const {selectedPages, selectedPagesName} = action.payload;
      for (let i=0;i<state.pages.length;i++) {
        state.pages[i].selected = selectedPages.includes(i);
        state.pages[i].name = selectedPagesName[i] || "";
      }
    },    

    addRoomStore: (state, action) => {
      state.rooms = [...state.rooms, action.payload];
    },
    removeRoomStore: (state, action) => {
      let id = action.payload;
      state.rooms = state.rooms.filter(x => x.id !== id);
    },
    updateRooms: (state, action) => {
      let room = action.payload;
      room.forEach(r => {
        let newR = state.rooms.find(x=>x.id === r.id);
        if (newR) {
          newR.name = r.name;
        }
      });
    },
    setRoomsStore: (state, action) => {
      let rooms = action.payload;
      state.rooms = rooms
    },

    addEvitementZoneStore: (state, action) => {
      state.evitementZones = [...state.evitementZones, action.payload];
    },
    removeEvitementZoneStore: (state, action) => {
      let id = action.payload;
      state.evitementZones = state.evitementZones.filter(x => x.id !== id);
    },
    setEvitementsStore: (state, action) => {
      let evitementZones = action.payload;
      state.evitementZones = evitementZones
    },

    addOpeningsStore: (state, action) => {
      // check if opening already exists
      let existing = state.openings.find(x => x.id === action.payload.id);
      if (!existing) {
        state.openings = [...state.openings, action.payload];
      }
    },
    removeOpeningsStore: (state, action) => {
      let id = action.payload;
      state.openings = state.openings.filter(x => x.id !== id);
    },
    setOpeningsStore: (state, action) => {
      let openings = action.payload;
      state.openings = openings
    },

    addEquipmentsStore: (state, action) => {
      let eq = action.payload;
      if(state.equipments.find(x => x.id === eq.id)) {
        return;
      }
      state.equipments = [...state.equipments, action.payload];
    },
    removeEquipmentsStore: (state, action) => {
      let id = action.payload;
      state.equipments = state.equipments.filter(x => x.id !== id);
    },  
    updateEquipment: (state, action) => {
      let equipment = action.payload;
      equipment.forEach(e => {
        let newE = state.equipments.find(x=>x.id === e.id);
        if (newE) {
          newE.name = e.name;
        }
      });
    },
    setEquipmentsStore: (state, action) => {
      let equipments = action.payload;
      state.equipments = equipments
    },
    updateEquipmentProperties: (state, action) => {
      const { id, hauteur, couleur, gamme, typeCable } = action.payload;
      let equipment = state.equipments.find(x => x.id === id);
      if (equipment) {
        if (hauteur !== undefined) equipment.hauteur = hauteur;
        if (couleur !== undefined) equipment.couleur = couleur;
        if (gamme !== undefined) equipment.gamme = gamme;
        if (typeCable !== undefined) equipment.typeCable = typeCable;
      }
    },
    updateSvgScale: (state, action) => {
      state.svgScale = action.payload;
    },

    addPieuvresStore: (state, action) => {
      // state.pieuvres = [...state.pieuvres, action.payload];
      state.pieuvres = [...state.pieuvres, ...action.payload];
    },
    removePieuvresStore: (state, action) => {
      let id = action.payload;
      state.pieuvres = state.pieuvres.filter(x => x.id !== id);
    },
    updatePieuvresStore: (state, action) => {
      let pieuvre = action.payload;      
      let newP = state.pieuvres.find(x=>x.id === pieuvre.id);
      if (newP) {
        newP.name = pieuvre.name;
        newP.fill = pieuvre.fill;
        newP.text_color = pieuvre.text_color;
      }
    },
    setPieuvresStore: (state, action) => {
      let pieuvres = action.payload;
      state.pieuvres = pieuvres
    },
    addCableToPieuvre: (state, action) => {
      const { pieuvreId, cableId, equipmentId } = action.payload;
      let pieuvre = state.pieuvres.find(x => x.id === pieuvreId);
      if (pieuvre) {
        if (!pieuvre.cables) pieuvre.cables = [];
        if (!pieuvre.connectedEquipments) pieuvre.connectedEquipments = [];
        if (!pieuvre.cables.includes(cableId)) {
          pieuvre.cables.push(cableId);
        }
        if (!pieuvre.connectedEquipments.includes(equipmentId)) {
          pieuvre.connectedEquipments.push(equipmentId);
        }
      }
    },
    removeCableFromPieuvre: (state, action) => {
      const { pieuvreId, cableId, equipmentId } = action.payload;
      let pieuvre = state.pieuvres.find(x => x.id === pieuvreId);
      if (pieuvre) {
        if (pieuvre.cables) {
          pieuvre.cables = pieuvre.cables.filter(id => id !== cableId);
        }
        if (pieuvre.connectedEquipments) {
          pieuvre.connectedEquipments = pieuvre.connectedEquipments.filter(id => id !== equipmentId);
        }
      }
    },

    addCablesStore: (state, action) => {
      state.cables = [...state.cables, ...action.payload];
    },
    removeCablesStore: (state, action) => {
      let id = action.payload;
      state.cables = state.cables.filter(x => x.id !== id);
    },
    updateCableStore: (state, action) => {
      let cable = action.payload;
      let newC = state.cables.find(x=>x.id === cable.id);
      if (newC) {
        newC.stroke = cable.stroke;
      }
    },
    updateCablesStore: (state, action) => {
      let cablesToUpdate = action.payload;      
      cablesToUpdate.forEach(cable => {
        let existingCable = state.cables.find(x=>x.id === cable.id);
        if (existingCable) {
          existingCable.stroke = cable.stroke;
        }
      });
    },
    setCablesStore: (state, action) => {
      let cables = action.payload;
      state.cables = cables
    },
    updatePolygonPoints: (state, action) => {
      const { id, points, type } = action.payload;

      if (type === "rooms") {
        let room = state.rooms.find(x => x.id === id);
        if (room) {
          room.points = points;
        } 
      }
      else if (type === "evitements") {
        let evitement = state.evitementZones.find(x => x.id === id);
        if (evitement) {
          evitement.points = points;
        } 
      }
    },
    updatePolylinesPoints: (state, action) => {
      const { id, points } = action.payload;
      let cable = state.cables.find(x => x.id === id);
      if (cable) {
        cable.points = points;
      }
    },
    updateSvgPoints: (state, action) => {
      const { id, left, top, type, angle } = action.payload;

      if (type.includes("pieuvre")) {
        let pieuvre = state.pieuvres.find(x => x.id === id);
        if (pieuvre) {
          pieuvre.x = left;
          pieuvre.y = top;
        } 
      }
      else {
        let equip = state.equipments.find(x => x.id === id);
        if (equip) {
          equip.left = left;
          equip.top = top;
          equip.angle = angle;
        } 
      }
    }
  }
});

export const {
  setFileConfigurationIEP,
  updatePagesIEP,
  setCurrentFileSelectedPagesIEP,
  addRoomStore,
  removeRoomStore,
  setRoomsStore,
  addOpeningsStore,
  removeOpeningsStore,
  addEquipmentsStore,
  removeEquipmentsStore,
  setOpeningsStore,
  updateRooms,
  updateEquipment,
  updateEquipmentProperties,
  setEquipmentsStore, 
  updateSvgScale,
  addPieuvresStore,
  removePieuvresStore,
  updatePieuvresStore,
  setPieuvresStore,
  addCableToPieuvre,
  removeCableFromPieuvre,
  addCablesStore,
  removeCablesStore,
  updateCableStore,
  setCablesStore,
  updateCablesStore,
  addEvitementZoneStore,
  removeEvitementZoneStore,
  setEvitementsStore,
  updatePolygonPoints,
  updateSvgPoints,
  updatePolylinesPoints
} = Configuration.actions;

export default Configuration.reducer;